import './fix-routes'
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import paths from './paths'
import _ from 'lodash'

function route(path, view, name, free, redirect) {
  const routeName = name || (!redirect ? view : undefined)
  return {
    name: routeName,
    path: path.replace(/\/{2,}/g, '/'), // Remove // das rotas definidas
    props: { free },
    redirect,
    component: () => import(`@/views/${view}.vue`),
    meta: {
      title: _.get(name, '[0]')
    }
  }
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(
    path.path, 
    path.view, 
    path.name, 
    path.free !== undefined ? path.free : false, 
    path.redirect
  )).concat([
    { path: '*', redirect: '/dashboard', props: { free: true } }
  ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {

  if (!localStorage.getItem('user') && !_.get(to, 'matched[0].props.default.free')) {
    const urlParams = new URLSearchParams(window.location.search)
    const isMobileAccess = urlParams.get('mobileaccess') === '1' || 
                          sessionStorage.getItem('handless_mode') === '1'
    const token = urlParams.get('token')
    
    if (to.path !== '/user' || isMobileAccess) {
      sessionStorage.setItem('lastPage', to.fullPath)
    }
    
    if (isMobileAccess) {
      next()
    } else {
      next({
        path: '/login',
        query: { 
          redirect: to.fullPath,
          ...(token && { token })
        }
      })
    }
  } else if (to.path === '/login' && localStorage.getItem('user')) {
    next('/dashboard')
  } else {
    next()
  }
})

Vue.use(Meta)
export default router